module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-lan-3d82aaaefaf9a73a2c393f12ecea3871.png";